import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import ErrorDialog from './ErrorDialog';
import RegistrationForm from './RegistrationForm';
import Logo from '../img/Logo-Msggme.png';

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  palette: {
    primary: { main: '#FFD700' },
    secondary: { main: '#000000' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          background-color: #000000;
          color: #FFFFFF;
        }
      `,
    },
  },
});

const Root = styled(Grid)(() => ({ height: '100vh' }));
const ImageContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));
const PaperContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(2),
  height: '100%',
}));
const Form = styled('form')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
}));
const SubmitButton = styled(Button)(({ theme }) => ({
  margin: `${theme.spacing(3)} 0 ${theme.spacing(2)}`,
  backgroundColor: '#FFFF00',
  color: '#000000',
  '&:hover': { backgroundColor: '#FFD700' },
}));

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [openRegistrationDialog, setOpenRegistrationDialog] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'https://toolbox.msgg.me/api/login',
        { username, password }
      );

      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('userRole', response.data.role);
      localStorage.setItem('username', response.data.username);

      navigate('/main');
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || 'Login failed');
      } else {
        setError('Network error occurred');
      }
      setOpenErrorDialog(true);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Root container component="main">
        <ImageContainer item xs={false} sm={4} md={7}>
          <img src={Logo} style={{ width: '100%', height: 'auto' }} alt="Logo" />
        </ImageContainer>
        <PaperContainer item xs={12} sm={8} md={5} elevation={6} square>
          <Form onSubmit={handleLogin}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <SubmitButton type="submit" fullWidth variant="contained">
              Login
            </SubmitButton>
            <Button
              fullWidth
              variant="text"
              onClick={() => setOpenRegistrationDialog(true)}
            >
              Register
            </Button>
          </Form>
        </PaperContainer>
      </Root>

      <ErrorDialog
        open={openErrorDialog}
        onClose={() => setOpenErrorDialog(false)}
        message={error}
      />

      <RegistrationForm
        open={openRegistrationDialog}
        onClose={() => setOpenRegistrationDialog(false)}
      />
    </ThemeProvider>
  );
};

export default Login;